import { Box } from '@mui/material';
import React from 'react';
import { CurrentUser } from 'src/features/user/constants';
import { DefaultCourt } from './DefaultCourt';
import { SignatureBlock } from './SignatureBlock';
import { AddressesBlock } from './AddressesBlock';
import AutoExcludeList from './AutoExcludeList';
import DocumentDescriptions from './DocumentDescriptions';
import { OrganizationType } from 'src/utils/enums/organization-type.enum';

interface DefaultTabProps {
  currentUser: CurrentUser;
}

const DefaultTab: React.FC<DefaultTabProps> = ({ currentUser }) => {
  return (
    <Box>
      <DefaultCourt currentUser={currentUser} />
      <AddressesBlock currentUser={currentUser} />
      <SignatureBlock currentUser={currentUser} />
      {currentUser.organization.type === OrganizationType.CHAPTER_13_TRUSTEE && (
        <>
          <DocumentDescriptions />
          <AutoExcludeList />
        </>
      )}
    </Box>
  );
};

export default DefaultTab;
